import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { styleSheet } from '../../assets/styles/global';
import { X } from 'phosphor-react';

export const SideMenuContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Align content to start */
  justify-content: flex-start; /* Align vertically to top */

  height: 100%;
  width: 100%; /* Will fill the Sidebar component which we will set to auto */
  min-width: 200px; /* Minimum width to look good */
  white-space: nowrap; /* Prevent text wrapping */
`;

export const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 15px;
  margin-bottom: 2rem;
`;

export const CloseButton = styled(X)`
  cursor: pointer;
  color: #54278b;
  transition: opacity 0.2s;
  margin-top: -5px;
  margin-right: -5px;

  &:hover {
    opacity: 0.7;
  }
`;

export const CustomMenuItem = styled.div<{ active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-start; /* Align left */
  padding: 15px 20px;
  width: 100%;
  cursor: pointer;
  transition: all 0.2s;
  color: ${({ active }) => active ? '#FF8C00' : '#54278b'}; /* Orange if active, Purple otherwise */
  font-weight: ${({ active }) => active ? '600' : '400'};
  font-size: 1.4rem;
  border-left: ${({ active }) => active ? '3px solid #FF8C00' : '3px solid transparent'};

  &:hover {
    background-color: rgba(84, 39, 139, 0.05);
    color: ${({ active }) => active ? '#FF8C00' : '#54278b'};
  }

  svg {
    margin-right: 15px;
    color: ${({ active }) => active ? '#FF8C00' : '#54278b'};
  }
`;

export const SideMenuList = styled.ul`
  display: flex;
  flex-direction: column;
`;

export const SideMenuListItem = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;

  cursor: pointer;
  list-style: none;
  margin: 3rem 0;
`;

export const MenuListText = styled.span`
  color: ${styleSheet.shapeDark};
  font-size: 1.5rem;
  margin-top: 1rem;
`;

export const MainLogo = styled.img`
  width: 4rem;
`;

export const VersionContainer = styled.div`
  text-align: center;
  position: absolute;
  bottom: 5px;
  width: 100%;
`;

export const VersionText = styled.span`
  font-size: 1.4rem;
  color: #fff;
`;